import { memo } from 'react';
import {
    Card,
    Image,
    Section,
    Tabs,
    Title,
} from '@zmedia/bm-soccer-ui/components';
import styles from './style.module.scss';

export function TeamHeader(props: any) {
    const { country, name, logo, tab, seasonName, path, activeTab } = props;
    return (
        <Section className={styles['team-header']}>
            <Card>
                <Card.Image>
                    <Image src={logo} alt={name} />
                </Card.Image>
                <Card.Content>
                    <Title renderAs="h2">
                        {name} {seasonName}
                    </Title>
                    {country?.name && (
                        <Title subtitle renderAs="div">
                            <Image src={country?.logo} alt={country?.name} />
                            {country?.name}
                        </Title>
                    )}
                </Card.Content>
            </Card>
            <Tabs tabs={tab.items} pathUrl={path} activeTab={activeTab}></Tabs>
        </Section>
    );
}

export default memo(TeamHeader);
